module.exports = __webpack_public_path__ + "media/images/sme-347d5d4b4596801213db00ee8b26829a.png";